import { getAllComposerTypes, getIntegrationComposerTypes } from '../../screens/leadModal/lib/composerTypes.js';
import querySelector from './querySelector.js';
import { getHashMap } from '../../lib/getHashMap.js';

const activeComposerTypeSelector = (state) => {
  const type = querySelector('type')(state);
  let composerTypes = getAllComposerTypes();
  let activeComposerType = composerTypes.find((n) => n.type === String(type));

  const integrationsMap = getHashMap(getIntegrationComposerTypes(), 'type');
  const currentIntegrationsMap = getHashMap(
    (state.currentServiceProvider.platformRegistrations || []).filter((el) => el.platform_type === 'integration'),
    'platform_code'
  );

  // add integration_id to activeComposerType, will be used by the integration components
  if (type && integrationsMap[type] && currentIntegrationsMap[type]) {
    activeComposerType.integration_id = currentIntegrationsMap[type].id;
  }

  return activeComposerType;
};

export default activeComposerTypeSelector;
